import Checkbox from "@material-ui/core/Checkbox";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import TablePagination from "@material-ui/core/TablePagination";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import { rowsPerPage } from "../../../utils/setting";
import Snackbar from "../../snackbar";
import { styles } from "./styles";
import EnhancedTableHead from "./tableHead";
import Loading from "../../loading";
import AddCustomer from "./addCustomer";
function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "",
      orderBy: "",
      selected: [],
      data: [
        // can tao data
      ],
      page: 0,
      rowsPerPage: rowsPerPage,
      listCustomer: [],
      collapse: [],
    };
    this.statusArray = [
      {
        key: "Male",
        value: 5,
        color: "#e1d224",
      },
      {
        key: "Female",
        value: 6,
        color: "#aea7a7",
      },
      {
        key: "Other",
        value: 2,
        color: "#d03535",
      },
    ];
    this.getIdCustomer = this.getIdCustomer.bind(this);
  }
  componentDidMount = () => {
    this.props.onRef(this);
    this.getListCustomer({
      limit: this.state.rowsPerPage,
      page: this.state.page,
    });
    // this.setState({ listCustomer: this.props.listCustomer })
  };
  getIdCustomer() {
    return this.state.selected.map((item) => {
      let index = item.indexOf("-");
      let countryCode = item.slice(0, index);
      let valuePhoneNumber = item.slice(index + 1, item.length);
      let customer = this.props.listCustomer.find(
        (item) =>
          item.countryCode === countryCode &&
          item.customerMobile === valuePhoneNumber
      );
      if (customer) {
        return {
          countryCode: countryCode,
          valuePhoneNumber: valuePhoneNumber,
          customerName: customer.customerName,
        };
      } else {
        return {
          countryCode: countryCode,
          valuePhoneNumber: valuePhoneNumber,
        };
      }
    });
  }
  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({
        selected: this.props.listCustomer.map(
          (n) => n.countryCode + "-" + n.customerMobile
        ),
      }));
      this.props.selectedList(true);
      return;
    }
    this.props.selectedList(false);
    this.setState({ selected: [] });
  };
  resetSelected = () => {
    this.setState({ selected: [] });
  };
  checkSentUser = (id) => {
    let index = id.indexOf("-");
    let countryCode = id.slice(0, index);
    let valuePhoneNumber = id.slice(index + 1, id.length);
    this.props.checkSentUser({
      id: id,
      countryCode: countryCode,
      mobile: valuePhoneNumber,
    });
  };
  handleClick = (id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
    this.props.selectedList(newSelected.length ? true : false);
  };

  handleChangePage = (event, page) => {
    this.getListCustomer({ limit: this.state.rowsPerPage, page: page });
    this.setState({ page, selected: [] });
  };

  handleChangeRowsPerPage = (event) => {
    this.getListCustomer({ limit: event.target.value, page: this.state.page });

    this.setState({ rowsPerPage: event.target.value, selected: [] });
  };
  getListCustomer = async (payload) => {
    let { t } = this.props;
    this.loading.startLoading();
    let check = await this.props.customerDispatch.getListCustomer(payload);
    if (check.code === 1 && !check.data.list.length)
      this.mSnackbar.handleClick(t("customer_not_found_any_customer"), "error");
    this.loading.stopLoading();
  };
  handleSearch = async (value) => {
    this.getListCustomer({
      limit: this.state.rowsPerPage,
      page: this.state.page,
      search: value,
    });
  };
  openDialogAddCustomer = () => {
    this.AddCustomer.handleDialogOpen();
  };
  isSelected = (id) => this.state.selected.indexOf(id) !== -1;
  addCustomer = async (customer) => {
    let { t } = this.props;
    this.AddCustomer.handleDialogClose();
    this.loading.startLoading();
    let check = await this.props.customerDispatch.createCustomer(customer);
    if (check && check.code === 1) {
      this.getListCustomer({
        limit: this.state.rowsPerPage,
        page: this.state.page,
      });
      this.mSnackbar.handleClick(t("customer_create_customer_successfully"));
    } else {
      if (check.error === 1109)
        this.mSnackbar.handleClick(
          t("customer_customer_existed_please_try_again"),
          "error"
        );
      else if (check.error === 1107)
        this.mSnackbar.handleClick(
          t("you_not_permission_add_customer"),
          "error"
        );
      else
        this.mSnackbar.handleClick(
          t("customer_create_customer_unsuccessfully") + " " + check.message,
          "error"
        );
    }
    this.loading.stopLoading();
  };
  render() {
    const { classes, t, count } = this.props;
    const { order, orderBy, selected, rowsPerPage, page } = this.state;
    const listCustomer = this.props.listCustomer;
    const emptyRows = 0;
    return (
      <div>
        <AddCustomer
          onRef={(id) => {
            this.AddCustomer = id;
          }}
          addCustomer={this.addCustomer}
        />
        <Paper className={classes.root}>
          <Snackbar
            color="white"
            onRef={(snackbar) => (this.mSnackbar = snackbar)}
          />
          <Loading onRef={(id) => (this.loading = id)} />
          <div className={classes.tableWrapper}>
            <Table>
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={listCustomer.length}
              />
              <TableBody>
                {stableSort(listCustomer, getSorting(order, orderBy))
                  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((n, index) => {
                    const isSelected = this.isSelected(
                      n.countryCode + "-" + n.customerMobile
                    );
                    let validPhone = _parsePhoneNumber(
                      n.countryCode,
                      n.customerMobile
                    ).format_internal;
                    return [
                      <TableRow
                        hover
                        onClick={() =>
                          this.props.checkSentUser
                            ? this.checkSentUser(
                                n.countryCode + "-" + n.customerMobile
                              )
                            : this.handleClick(
                                n.countryCode + "-" + n.customerMobile
                              )
                        }
                        disabled={n.status === "cancel" ? true : false}
                        aria-checked={isSelected}
                        tabIndex={-1}
                        key={n.id + "row"}
                        selected={isSelected}
                        className={classes.root}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox checked={isSelected} color="primary" />
                        </TableCell>
                        <TableCell padding="dense">
                          {n.haveAccount ? (
                            <img
                              style={{ width: "1.5rem" }}
                              src="../../../rectangle-logo.png"
                              alt="icon account"
                            />
                          ) : (
                            ""
                          )}
                        </TableCell>
                        <TableCell padding="dense">{n.customerName}</TableCell>
                        <TableCell padding="dense">{validPhone}</TableCell>
                        <TableCell padding="dense">
                          {t(n.customerGender || "other")}
                        </TableCell>
                        <TableCell padding="dense">
                          {n.customerDistrict}
                        </TableCell>
                        <TableCell padding="dense">{n.customerCity}</TableCell>
                      </TableRow>,
                    ];
                  })}
                {emptyRows > 0 ? (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={9} />
                  </TableRow>
                ) : (
                  ""
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
            labelRowsPerPage={t("rows_per_page")}
            labelDisplayedRows={({ from, to, count }) => `${from}- ${to}`}
          />
        </Paper>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  total: state.customer.total,
  count: state.customer.count,
  listCustomer: state.customer.listCustomer,
});

const mapDispatch = (dispatch) => ({
  checkSentUserMembercard: dispatch.userMembercard.checkSentUserMembercard,
  customerDispatch: dispatch.customer,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(EnhancedTable)
  )
);
